import { bindable, bindingMode } from 'aurelia-framework';

export class AppMessage {
  @bindable messagekey: String;
  @bindable messageclass: String;
  @bindable messageautocloseafter: Number;

  constructor() {}
}
